import { render, staticRenderFns } from "./EmbeddedAppsDisplay.vue?vue&type=template&id=645d3210&scoped=true"
import script from "./EmbeddedAppsDisplay.vue?vue&type=script&lang=js"
export * from "./EmbeddedAppsDisplay.vue?vue&type=script&lang=js"
import style0 from "./EmbeddedAppsDisplay.vue?vue&type=style&index=0&id=645d3210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645d3210",
  null
  
)

export default component.exports